var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H11.5C12.163 0 12.7989 0.263392 13.2678 0.732233C13.7366 1.20107 14 1.83696 14 2.5V7.5C14 7.8283 13.9353 8.15339 13.8097 8.45671C13.6841 8.76002 13.4999 9.03562 13.2678 9.26777C13.0356 9.49991 12.76 9.68406 12.4567 9.8097C12.1534 9.93534 11.8283 10 11.5 10H7.688L4.625 12.68C4.48327 12.8039 4.30885 12.8844 4.12261 12.9118C3.93636 12.9391 3.74617 12.9123 3.57476 12.8345C3.40336 12.7566 3.25801 12.6311 3.15608 12.4728C3.05415 12.3145 2.99996 12.1303 3 11.942V10H2.5C1.83696 10 1.20107 9.73661 0.732233 9.26777C0.263392 8.79893 0 8.16304 0 7.5V2.5ZM2.5 1C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V7.5C1 7.89782 1.15804 8.27936 1.43934 8.56066C1.72064 8.84196 2.10218 9 2.5 9H4V11.898L7.312 9H11.5C11.8978 9 12.2794 8.84196 12.5607 8.56066C12.842 8.27936 13 7.89782 13 7.5V2.5C13 2.10218 12.842 1.72064 12.5607 1.43934C12.2794 1.15804 11.8978 1 11.5 1H2.5Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/commentIcon.e5d7847efc1f05c854ac1730e053fdbe.svg";
export { ForwardRef as ReactComponent };